module.exports = __webpack_public_path__ + "img/37.f6f7b922.jpg";